import WordsPullUp from './WordsPullUp';

interface Props {
  animate?: boolean;
  italic?: boolean;
  className?: string;
}

/**
 * The Kirkjoserey wordmark. When `animate` is set and the document is
 * visible (i.e. not a hidden iframe preview), the chars rise into place
 * one-by-one via WordsPullUp. Otherwise it renders statically — the
 * wordmark must NEVER be invisible just because animations don't run.
 */
export default function Kirkmark({ animate = false, italic = false, className = '' }: Props) {
  const base =
    'font-display font-display-axes inline-block relative leading-[0.85] tracking-[-0.05em] font-normal';
  return (
    <span className={`${base} ${italic ? 'italic font-display-italic-axes' : ''} ${className}`}>
      {animate ? <WordsPullUp text="Kirkjoserey" stagger={0.045} /> : 'Kirkjoserey'}
      <span className="kirkmark-dot" />
    </span>
  );
}
